export default __webpack_public_path__ + "static/media/jadecitadelcourtyard.dab4c8ec.jpg";